import { Box, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const CHOICE_ORDER = ['A', 'B', 'C', 'D', 'E', 'F'];

const orderedChoiceKeys = (choices) => {
  const keys = Object.keys(choices || {});
  const known = CHOICE_ORDER.filter((key) => keys.includes(key));
  const rest = keys.filter((key) => !CHOICE_ORDER.includes(key)).sort();
  return [...known, ...rest];
};

const QuestionTooltipContent = ({ row }) => {
  const choices = row.choices || {};
  const answerCounts = row.answerCounts || {};
  const correctAnswer = (row.correctAnswer || '').toUpperCase();
  const choiceKeys = orderedChoiceKeys(choices);

  return (
    <Box sx={{ p: 0.5, maxWidth: 360 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.75 }}>
        Question
      </Typography>
      <Typography variant="body2" sx={{ mb: 1.5, whiteSpace: 'pre-wrap' }}>
        {row.questionText || '—'}
      </Typography>
      {choiceKeys.length > 0 ? (
        <>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Answers
          </Typography>
          {choiceKeys.map((key) => {
            const isCorrect = key.toUpperCase() === correctAnswer;
            const count = answerCounts[key] ?? answerCounts[key.toUpperCase()] ?? 0;
            return (
              <Box
                key={key}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  gap: 2,
                  py: 0.5,
                  px: 1,
                  mb: 0.25,
                  borderRadius: 1,
                  bgcolor: isCorrect ? 'rgba(46, 125, 50, 0.15)' : 'transparent',
                  border: isCorrect ? '1px solid' : '1px solid transparent',
                  borderColor: isCorrect ? 'success.main' : 'transparent',
                }}
              >
                <Typography variant="body2" component="span" sx={{ flex: 1 }}>
                  <strong>{key}.</strong> {choices[key]}
                </Typography>
                <Typography variant="body2" component="span" sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>
                  {count}
                </Typography>
              </Box>
            );
          })}
        </>
      ) : null}
    </Box>
  );
};

const tooltipSlotProps = {
  tooltip: {
    sx: {
      maxWidth: 400,
      bgcolor: 'background.paper',
      color: 'text.primary',
      boxShadow: 3,
      border: '1px solid',
      borderColor: 'divider',
      p: 1,
      '& .MuiTooltip-arrow': {
        color: 'background.paper',
        '&::before': {
          border: '1px solid',
          borderColor: 'divider',
        },
      },
    },
  },
};

const DqQuestionIdCell = ({ row }) => (
  <Tooltip
    title={<QuestionTooltipContent row={row} />}
    placement="right"
    arrow
    enterDelay={200}
    slotProps={tooltipSlotProps}
  >
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        cursor: 'help',
      }}
    >
      {row.questionId}
      <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', opacity: 0.75 }} />
    </Box>
  </Tooltip>
);

export default DqQuestionIdCell;
